import { MdCheck } from 'react-icons/md'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const StyleButton = styled(Button)`
  margin-right: 15px;
`
export const Message = styled.div`
  width: 100%;
  height: 100%;
`

export const ContainerIcon = styled.div`
  display: flex;
  width: 75px;
  height: 75px;
  align-items: center;
  justify-content: center;

  svg {
    width: 75px;
    height: 75px;
  }
`
export const IconBorder = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;
  }
`

export const StyledCancelButton = styled(Button)`
  background: transparent;
  color: ${colors.red};
  border: 1px solid ${colors.red};
  margin-right: 10px;
`

export const StyledCheck = styled(MdCheck)<{
  color?: string
  fontSize?: number
}>`
  border: 3px solid ${p => (p.color ? p.color : colors.blue)};
  border-radius: 50%;
`
